import {dateToTs, tsToServerDate} from "./ages";
import {Holiday} from "../models/classes.model";

/**
 * Full-day holiday date math, shared by every surface that renders a holiday
 * (home card, slots closed-day notice, slot row line).
 *
 * Holiday bounds are API date-timestamps; they are decoded to the local-midnight
 * timestamp of the same calendar date so they compare against calendar chips.
 */

const decode = (bound: number): number => dateToTs(tsToServerDate(bound));

/** First holiday (store order) whose dates cover the local-midnight `ts`. */
export const holidayForTs = (holidays: Holiday[], ts: number): Holiday | undefined =>
    holidays.find(h => decode(h.startDateTs) <= ts && ts <= decode(h.endDateTs));

export const isHolidayTs = (holidays: Holiday[], ts: number): boolean => !!holidayForTs(holidays, ts);

/** Holidays still running today or starting within `days` days, in store order. */
export const upcomingHolidays = (holidays: Holiday[], today: Date, days: number = 28): Holiday[] => {
    const from = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const horizon = dateToTs(new Date(from.getFullYear(), from.getMonth(), from.getDate() + days));
    const fromTs = dateToTs(from);
    return holidays.filter(h => decode(h.endDateTs) >= fromTs && decode(h.startDateTs) <= horizon);
};

export const isMultiDay = (holiday: Holiday): boolean => decode(holiday.endDateTs) !== decode(holiday.startDateTs);
